import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useState } from "react";

const MobileDistributionWarehouse = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="p-8">
      <div>
        <div className="flex flex-col space-y-5 ">
          <TextGradient>
            <span className="h2">04</span>
          </TextGradient>
          <p className="mobile-h3 2xs:mobile-h2 text-background-primary-dark">
            Distribution Centers & Warehouses
          </p>
          <GradientContainer overrideClassName="w-[30%] h-2" />
          <div className="text-text-color-mid-em-light space-y-5">
            <p>
              Capitalize on savings and efficiency through our Sole Source Management program.
            </p>
            <p>
              A combination of technology, purchasing, and operations support provides
              your management teams with the tools necessary for streamlined service delivery
              with 100% transparency.
            </p>
            {isExpanded && (
              <div>
                <p>
                  Waste profile management and equipment optimization are integral for the
                  collection and handling of the unique waste and recycling byproducts
                  generated from DC and Warehouse facilities.
                </p>
              </div>
            )}
          </div>
          <div>
            <Button onClick={() => setIsExpanded(!isExpanded)}>
              {isExpanded ? 'Read less' : 'Read more'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MobileDistributionWarehouse;